import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=98a6b0aa&scoped=true&"
import script from "./NoticeModal.vue?vue&type=script&lang=js&"
export * from "./NoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&id=98a6b0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a6b0aa",
  null
  
)

export default component.exports